import { render, staticRenderFns } from "./Home.domains-edit.vue?vue&type=template&id=64875f5a&scoped=true&"
import script from "./Home.domains-edit.vue?vue&type=script&lang=js&"
export * from "./Home.domains-edit.vue?vue&type=script&lang=js&"
import style0 from "./Home.domains-edit.vue?vue&type=style&index=0&id=64875f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64875f5a",
  null
  
)

export default component.exports